module.exports = __webpack_public_path__ + "static/img/content_bg_ar.efb5174d.png";